module.exports = __webpack_public_path__ + "media/images/athletes/1397-e2713319e3e6fb97f7cdb9fa199eda61.png";